import { Link } from "react-router";

import { CLAIM_CONTRACT, NETWORK_NAME, SUPPORT_URL, explorerAddress } from "@/lib/config";
import { CopyAction } from "./ui";
import { CspImage } from "./CspImage";

const FOOTER_LINKS = [
  { href: "/claim", label: "Migrasi" },
  { href: "/verify", label: "Verifikasi" },
  { href: "/contract-addresses", label: "Kontrak resmi" },
  { href: "/security", label: "Keamanan" },
];

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <Link to="/" className="site-footer__brand-link">
            <span className="brand-mark brand-mark--footer">
              <CspImage src="/asetqu.png" alt="" width={64} height={64} />
            </span>
            <span>
              <strong>AsetQu</strong>
              <span>Migration Terminal</span>
            </span>
          </Link>
          <p>
            Infrastruktur publik untuk migrasi AsetQu Legacy, verifikasi kontrak,
            dan pembuktian transaksi di {NETWORK_NAME}.
          </p>
          <div className="site-footer__chain">
            <span aria-hidden /> Terhubung ke {NETWORK_NAME}
          </div>
        </div>

        <div className="site-footer__column">
          <p>Navigasi</p>
          <nav aria-label="Navigasi footer">
            {FOOTER_LINKS.map((item) => (
              <Link key={item.href} to={item.href}>
                {item.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="site-footer__column">
          <p>Kontrak migrasi resmi</p>
          {CLAIM_CONTRACT ? (
            <div className="site-footer__contract">
              <code>{CLAIM_CONTRACT}</code>
              <span>
                <CopyAction value={CLAIM_CONTRACT} label="Salin" />
                <a href={explorerAddress(CLAIM_CONTRACT)} target="_blank" rel="noopener noreferrer">
                  Explorer <span aria-hidden>↗</span>
                </a>
              </span>
            </div>
          ) : (
            <span>Kontrak migrasi belum dikonfigurasi.</span>
          )}
          {SUPPORT_URL ? (
            <a
              href={SUPPORT_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Kanal dukungan resmi <span aria-hidden>↗</span>
            </a>
          ) : (
            <span>Kanal support belum dikonfigurasi.</span>
          )}
        </div>
      </div>
      <div className="site-footer__bottom">
        <span>© {new Date().getFullYear()} AsetQu</span>
        <span>Proof before persuasion · Rasio migrasi 1:1</span>
      </div>
    </footer>
  );
}
